
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayStacked25 as ObiTwowayStacked25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-stacked-25.js';
 
 
 

 
 export const ObiTwowayStacked25 = createComponent({
   react: React,
   tagName: 'obi-twoway-stacked-25',
   elementClass: ObiTwowayStacked25Element,
   events: {
     
   }
  });
 
 